import React from "react";

const AdminToggleActiveIcon = ({ width, height, color }) => {
  return (
    <svg
      width="35"
      height="18"
      viewBox="0 0 35 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="35" height="18" rx="9" fill="#31A727" />
      <ellipse
        cx="9.47911"
        cy="8.99999"
        rx="8.50694"
        ry="8.07692"
        fill="white"
      />
    </svg>
  );
};

export default AdminToggleActiveIcon;
